export default __webpack_public_path__ + "static/consibio-b845dac2b61221d1f97b094d5cfe0ec9.svg";